import { NotificationStack } from 'react-notification';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { dismissNotification } from './notifications.actions';

const mapStateToProps = ({ notifications }) => ({ notifications });
const mapDispatchToProps = dispatch => bindActionCreators({ onDismiss: dismissNotification }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(NotificationStack);



// WEBPACK FOOTER //
// ./src/components/notifications/notifications.js